import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

import { ref } from "vue";
import HelpText from "@/guiide/ts/helpText";
import Help from "@/guiide/components/common/Help.vue";
import FinalSalaryScheme from "@/guiide/ts/assets/finalsalary/finalSalaryScheme";
import SummaryRadioGroup from "../common/SummaryRadioGroup.vue";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

enum ImportantInfoOption {
    Inflation,
    LifeExpectancy
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImportantInformation',
  props: {
    scheme: { type: Object as () => FinalSalaryScheme, required: true }
},
  setup(__props) {

const props = __props;

const { htmlArray } = useUIContent();

const selectedOption = ref<ImportantInfoOption>(ImportantInfoOption.Inflation);

const options = [
    {
        type: ImportantInfoOption.Inflation,
        name: "Inflation",
        description: ["Inflation is the term used to describe the general rise in the price of goods and services over time. This means that, to maintain your current lifestyle, your income also needs to increase as prices go up."],
        icon: "bi-graph-up-arrow",
        abbreviation: ""
    },
    {
        type: ImportantInfoOption.LifeExpectancy,
        name: "Life expectancy",
        description: [`Life expectancy is the average number of years a person is expected to live. Your ${props.scheme.name} pays income for life, so you'll always receive a pension. However, life expectancy still matters when choosing options. This part of the tool assumes you have an average life expectancy. Later, we'll check how your retirement plan works if you live longer than average.`],
        icon: "bi-heart-pulse",
        abbreviation: ""
    }
];

function getHelpTitle(option: ImportantInfoOption): string {
    if (option == ImportantInfoOption.Inflation) {
        return "Inflation";
    } else if (option == ImportantInfoOption.LifeExpectancy) {
        return "Life expectancy";
    }

    return "";
}

function getHelpText(option: ImportantInfoOption): Array<string> {
    if (option == ImportantInfoOption.Inflation) {
        return htmlArray('dboptions.important-info.inflation.read-more.body');
    } else if (option == ImportantInfoOption.LifeExpectancy) {
        return htmlArray('dboptions.important-info.life-expectancy.read-more.body');
    }

    return [];
}

function getLinkText(option: ImportantInfoOption): string {
    switch (option) {
        case ImportantInfoOption.Inflation:
            return "Read more about inflation.";
        case ImportantInfoOption.LifeExpectancy:
            return "Read more about life expectancy.";
        default:
            return "";
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "When choosing your option in the " + _toDisplayString(__props.scheme.name) + ", it's important to keep in mind that two key uncertainties could affect your decision:", 1),
    _createVNode(SummaryRadioGroup, {
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
      options: options
    }, {
      extraContent: _withCtx(({ selected }) => [
        _createVNode(Help, {
          title: getHelpTitle(selected as ImportantInfoOption),
          text: getHelpText(selected as ImportantInfoOption),
          "link-text": getLinkText(selected as ImportantInfoOption)
        }, null, 8, ["title", "text", "link-text"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})